import React from 'react';
import { connect } from 'react-redux';
import './checkout.scss';
import Addresses from 'components/web/Address/Addresses';
import history from 'hb-redux-store/history';
import { getCheckoutRoute } from './checkout.routes';
import Drawer from 'components/common/Drawer';
import { showAddressListModal } from 'hb-redux-store/feature/modal/modal.action';
import { withRouter } from 'react-router-dom';
import {
  getSubscriptionRoute,
  subscriptionPrefix,
} from '../Subscription/subscription.routes';

class AddressList extends React.Component {
  constructor(props) {
    super(props);
    this.isSubscription =
      this.props.location?.pathname?.indexOf('subscription') > -1;
    this.state = {
      selectedAddressId: null,
      subscriptionAddress: this.isSubscription,
    };
  }

  goToShipment = address => {
    // set this as delivery address,
    console.log('Set deliveryAddress: ', address);
    let nextRoute = getCheckoutRoute('shipment');
    if (this.isSubscription) {
      nextRoute = getSubscriptionRoute('payment');
    }
    history.push(nextRoute);
  };

  render() {
    const source = this.isSubscription ? subscriptionPrefix : 'checkout';
    return (
      <div className="address-list">
        <Drawer
          title="SELECT ADDRESS"
          visible={this.props.addressListModal}
          placement="right"
          closable={true}
          onClose={() => {
            this.props.showAddressListModal(false);
          }}
          destroyOnClose={true}
          maskClosable={false}
          width={500}
        >
          <Addresses
            source={source}
            goToShipment={this.goToShipment}
            type="AddressList"
          />
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = ({ modalReducer }) => ({
  addressListModal: modalReducer.addressListModal,
});
const mapDispatchToProps = {
  showAddressListModal,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddressList)
);
